import {Dispatch} from "redux";
import {Action} from "../actions/flyersFiltersActions";
import {ActionType} from "../actionTypes";
import {OptionTypeBase} from "react-select/src/types";

export const changeFlyersViewFilter = (selectedFilter: OptionTypeBase) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_FLYERS_VIEW_FILTER,
            payload: selectedFilter
        });
    }
};

export const changeFlyersClassFilter = (selectedFilter: OptionTypeBase) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CHANGE_FLYERS_CLASSES_FILTER,
            payload: selectedFilter
        });
    }
};
